import { useEffect } from 'react';
import { useAlgoliaDataContext } from '../hooks/useAlgoliaDataContext';
import { algoliaViewHit } from '../events/algolia.viewHit';
import { defaultSearchParams, nbItemsPerPage, sortConfigByNameOrIndex } from '../configs';
import { SEARCH_PARAM_KEY_PAGE_NUMBER, SEARCH_PARAM_KEY_SORT } from '../constants/searchParamKeys';
import { useSearchParams } from 'react-router-dom';
export const DLViewHit = () => {
    const [searchParams] = useSearchParams();
    const { hits, queryID } = useAlgoliaDataContext();
    const sortConfig = sortConfigByNameOrIndex[searchParams.get(SEARCH_PARAM_KEY_SORT) ?? defaultSearchParams.index];
    const sortIndex = sortConfig?.index ?? defaultSearchParams.index;
    useEffect(() => {
        algoliaViewHit(sortIndex, queryID, hits, nbItemsPerPage * (+(searchParams.get(SEARCH_PARAM_KEY_PAGE_NUMBER) ?? 1) - 1) + 1);
    }, [queryID]);
    return null;
};
